{
  "index": {
    "title": "Team Members",
    "find": "Find Teachers",
    "create": "Add Teacher",
    "empty_list_title": "No Team Members",
    "empty_list_description": "Search for teachers to invite or add a teacher using their email address.",
    "profile": "Teacher Profile",
    "team_member_removed": "Team member removed."
  }
}
